import { takeLatest, put, call } from 'redux-saga/effects';

import { getLancamentos } from '../service';
import { storage } from '@commons/storage';
import {
  NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA,
  NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_PENDING,
  NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_SUCCESS,
  NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_FAILURE,
} from '../actionTypes';
import { CONFIG_SESSION } from '@handler/common/startSession';
import { formatDateDDMMYYYY } from '@components/common/format';
import { CONST_FILTER_MOVTO_CAIXA } from '@commons/consts';

function* sagaNewFilterNextPageControleContaCaixa(action) {
  yield put({ type: NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_PENDING })

  try {
    const idFazenda = JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id;

    let filterSaved = sessionStorage.getItem(CONST_FILTER_MOVTO_CAIXA) !== null ? JSON.parse(sessionStorage.getItem(CONST_FILTER_MOVTO_CAIXA)) : null;

    const datas = formatDateDDMMYYYY(filterSaved.dataInicial) + '_' + formatDateDDMMYYYY(filterSaved.dataFinal);

    let newFilter = {
      ...filterSaved,
      rows: action.rows,
      page: action.page,
    };

    let list = yield call(getLancamentos, idFazenda, newFilter.contaCaixa?.id ?? -1, datas, `&page=${newFilter.page}&size=${newFilter.rows}${newFilter.where}`);
      
    sessionStorage.setItem(CONST_FILTER_MOVTO_CAIXA, JSON.stringify(newFilter));

    yield put({
      type: NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_SUCCESS, list: list, filter: newFilter
    });
  } catch (error) {

    yield put({ type: NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_FAILURE })
    // console.error(error) // eslint-disable-line
  }
}

export default function* watchNewFilterNextPageControleContaCaixa() {
  yield takeLatest(NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA, sagaNewFilterNextPageControleContaCaixa)
}